import { render, staticRenderFns } from "./PopsRecevieAuth.vue?vue&type=template&id=e9074dec"
import script from "./PopsRecevieAuth.vue?vue&type=script&lang=js"
export * from "./PopsRecevieAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports